import { z } from 'zod';
import type { UserType } from '~/singlePageApp/screens/LiveStreamScreen/Broadcast/types/UserType';

export interface BaseUserData {
  email: string | null;
}

export interface UserDataWithRole extends BaseUserData {
  role: UserType;
}

export interface UserDataWithId extends BaseUserData {
  id: string;
}

export interface UserDataWithUserName extends BaseUserData {
  username: string;
}

export interface AllUserData extends UserDataWithId, UserDataWithUserName, UserDataWithRole {}

export const userIdSchema = z
  .object({
    id: z.string(),
  })
  .nullable();

export const userNameSchema = z.object({
  username: z.string(),
});

export const commonUserDataSchema = z
  .object({
    id: z.string(),
    username: z.string(),
  })
  .nullable();

export const userEmailSchema = z
  .object({
    email: z.string().nullable(),
  })
  .nullable();

export const userDataSchema = z
  .object({
    id: z.string(),
    username: z.string(),
    role: z.string(),
    email: z.string().nullable(),
  })
  .nullable();

export const extraUserDataSchema = userNameSchema.and(userEmailSchema).nullable();
